// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from '@/App'
import router from '@/router'
import axios from 'axios'
import auth from '@/services/auth'
import VueResource from 'vue-resource'
import {apiAcl, authUser, authACL, authHeader} from '@/functions/common.vue'

Vue.use(VueResource)
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.use(BootstrapVue)

router.beforeEach((to, from, next) => {
  var functionName
  var authCode
  var accessToken

  functionName = to.meta.functionName
  if (!localStorage.access_token)
  {
    if (functionName != 'login')
    {
      next({path: '/login'})
    }
    else
    {
      next()
    }
  }
  else
  {
    axios.post(apiAcl,{
      accessToken: localStorage.access_token,
      function: functionName
    }, authHeader())
      .then(res => {
        var r = res.data
        if (functionName == 'login')
          next({path: '/dashboard'})
        else
        {
          if (r.code == "0")
          {
            localStorage.clear()
            next('/login')
          }
          else if (r.code == "1")
          {
            localStorage.setItem("app_role", r.data.app_role)
            next()
          }
          else if (r.code == "2")
          {
            alert("You do not have access to selected module " + functionName + "!")
          }
        }
      })
      .catch(error => (alert(error))
      )
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js